// src/components/ui/toast/hooks/useToast.ts

import { useToastContext } from "../context/ToastContext";

/** Exposes the toast API from context. Client-only. */
export function useToast() {
  const { addToast, removeToast } = useToastContext();
  return { addToast, removeToast } as const;
}

export type { ToastInput, ToastType } from "../context/ToastContext";
